 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCVI from '@/components/OEBPS/cvi'
 import LOVE_1 from '@/components/love_1'
 import OEBPSTP from '@/components/OEBPS/tp'
 import OEBPSCOP from '@/components/OEBPS/cop'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSC01 from '@/components/OEBPS/c01'
 import LOVE_2 from '@/components/love_2'
 import OEBPSBM1 from '@/components/OEBPS/bm1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/c01",
 			"name" : "OEBPS/c01",
 			"component" : OEBPSC01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js